(function($){
    $(document).ready(function() {

        function customizeBreadCrumbsHomeLink() {
            var $BC = $('.js-breadcrumbs');
            if($BC.length) {
                var langSlug = $BC.attr('data-home-url');
                var $rootLink = $($BC.children('span')[0]).find('a');
                if(langSlug.length) {
                    $rootLink.attr('href',langSlug);
                }
            }
        }

        customizeBreadCrumbsHomeLink();

    });
})(jQuery);
